/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const VuesaxBoldEye = ({ className }) => {
  return (
    <svg
      className={`vuesax-bold-eye ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M17.7083 7.625C15.7833 4.6 12.9667 2.85834 9.99999 2.85834C8.51666 2.85834 7.07499 3.29167 5.75832 4.1C4.44166 4.91667 3.25832 6.10834 2.29166 7.625C1.45832 8.93334 1.45832 11.0583 2.29166 12.3667C4.21666 15.4 7.03332 17.1333 9.99999 17.1333C11.4833 17.1333 12.925 16.7 14.2417 15.8917C15.5583 15.075 16.7417 13.8833 17.7083 12.3667C18.5417 11.0667 18.5417 8.93334 17.7083 7.625ZM9.99999 13.3667C8.13332 13.3667 6.63332 11.8583 6.63332 10C6.63332 8.14167 8.13332 6.63334 9.99999 6.63334C11.8667 6.63334 13.3667 8.14167 13.3667 10C13.3667 11.8583 11.8667 13.3667 9.99999 13.3667Z"
        fill="white"
      />
      <path
        className="path"
        d="M10 7.61667C8.69167 7.61667 7.625 8.68334 7.625 10C7.625 11.3083 8.69167 12.375 10 12.375C11.3083 12.375 12.3833 11.3083 12.3833 10C12.3833 8.69167 11.3083 7.61667 10 7.61667Z"
        fill="white"
      />
    </svg>
  );
};
